import { ResponseException } from "../../Exceptions";
import { request } from "./api";


const cache = {
    lgus: {}
};

export async function getProvinceList() {
    if(cache.provinceList) return [...cache.provinceList];

    const response = await request("GET /meta/province");
    if(response.ok) {
        cache.provinceList = [...response.data];
        return response.data;
    }
    
    throw new ResponseException(response);
}


export async function getLGUList(province) {
    if(!province) if(cache.LGUList) return [...cache.LGUList];
    if(cache.lgus[province]) return [...cache.lgus[province]];    

    const response = await request(`GET /meta/lgu`, { query: { province } });
    if(response.ok) {
        if(!province) cache.LGUList = [...response.data];
        else cache.lgus[province] = [...response.data];
        return response.data;
    }
    
    throw new ResponseException(response);
}

export async function getAttractionList(lgu) {
    const response = await request(`GET /meta/attraction`, { query: { lgu } });
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}

export async function addAttraction(attraction) {
    const response = await request(`POST /meta/attraction`, { body: attraction });
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}

export async function updateAttraction(attraction) {
    const response = await request(`PATCH /meta/attraction/${attraction.id}`, { body: attraction });
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}

export async function deleteAttraction(id, password) {
    const response = await request(`DELETE /meta/attraction/${id}`, { headers: { password } });
    if(response.ok) return response.data;
    
    throw new ResponseException(response);
}


